import _ from 'lodash';
import { CANCEL } from '@sarunas/redux-debounce';
import { emitMessage } from './ws-actions';
import { getChannel } from '../services/ws-channel';
import { getTypingUserIds } from '../selectors/typing-selectors';

export const ADD_TYPING_USER = 'typing/ADD_USER';
export const REMOVE_TYPING_USER = 'typing/REMOVE_USER';
export const CLEAR_TYPING_USERS = 'typing/CLEAR_USERS';
export const START_TYPING_DEBOUNCED = 'typing/START_DEBOUNCED';

export const SOCKET_TYPING_MESSAGE = 'typing';
export const SOCKET_STOP_TYPING_MESSAGE = 'stop typing';

export function emitTyping(user, post) {
  const channel = getChannel({ type: 'post', ...post });
  return dispatch => {
    dispatch(emitMessage(SOCKET_TYPING_MESSAGE, channel, { user, post }));
  };
}

const EMIT_TYPING_TIMEOUT = 2000;
const REMOVE_TYPING_USER_TIMEOUT = 4000;

export function emitTypingThrottled(user, post) {
  const action = emitTyping(user, post);
  action.type = START_TYPING_DEBOUNCED;
  action.meta = {
    throttle: {
      wait: EMIT_TYPING_TIMEOUT,
      leading: true,
      trailing: true,
    },
  };
  return action;
}

export function addTypingUser({ user }) {
  return {
    type: ADD_TYPING_USER,
    payload: user,
  };
}

export const removeTypingUser = ({ user }) => dispatch =>
  dispatch({
    type: REMOVE_TYPING_USER,
    payload: user,
  });

const removeTypingUserDebouncedType = userId => `REMOVE_TYPING_USER_${userId}_DEBOUNCED`;

export function removeTypingUserDebounced(payload) {
  const action = removeTypingUser(payload);
  action.type = removeTypingUserDebouncedType(payload.user._id);
  action.meta = { debounce: REMOVE_TYPING_USER_TIMEOUT };
  return action;
}

export const clearTypingUsers = () => (dispatch, getState) => {
  dispatch({
    type: CANCEL,
    payload: {
      type: _.map(getTypingUserIds(getState()), removeTypingUserDebouncedType),
    },
  });

  dispatch({ type: CLEAR_TYPING_USERS });
};



// WEBPACK FOOTER //
// ./app/actions/typing-socket.js